// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2GmRK","modalFooterButton":"ModalNotes_modalFooterButton__3Bs0Q"};